import { Button } from '@mui/material';

const CustomButtonContained = ({
  onClick = () => { },
  startIcon = null,
  sx = {},
  title,
  disabled = false,
  ...rest
}) => {
  return (
    <Button
    className='CustomButtonContained'
      {...rest}
      sx={{
        ...sx,
        background: disabled ? 'lightgray !important' : '',
        px: { md: '20px', xs: 1 },
        py: { md: '8px', xs: 0.8 },
        fontSize: { md: '0.875rem', xs: '12px' }
      }}

      disabled={disabled}
      color="primary"
      variant="contained"
      startIcon={startIcon}
      onClick={onClick}
    >
      {title}
    </Button>
  );
};

export default CustomButtonContained;
